import { render } from "./DashboardTGECmp.vue?vue&type=template&id=fadb93ca&scoped=true"
import script from "./DashboardTGECmp.vue?vue&type=script&lang=js"
export * from "./DashboardTGECmp.vue?vue&type=script&lang=js"

import "./DashboardTGECmp.vue?vue&type=style&index=0&id=fadb93ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fadb93ca"]])

export default __exports__